import React, { useState } from "react"
import tw, { styled, css, theme } from "twin.macro"
import { Events, registerEvent } from "../../analytics"
import { ReactComponent as ShareIconSVG } from "../../assets/icons/shareIcon.svg"
import { Modal } from "../modal"
import { ShareContent, ShareContentProps } from "./shareContent"
import { Button } from "../formElements/button"
import { ReactComponent as ShareSVG } from "../../assets/icons/shareArrow.svg"

export enum IconSize {
  W44 = "w44",
  W44Fixed = "w44-fixed",
  W28 = "w28",
}

interface ShareIconProps {
  size?: IconSize
}
export const ShareIcon = styled(ShareIconSVG)(({ size }: ShareIconProps) => [
  tw`select-none`,
  tw`active:(cursor-pointer) hover:(cursor-pointer)`,
  css`
    &:active {
      .background {
        fill: ${theme<string>("colors.light-purple")};
      }
    }
    @media (hover: hover) and (pointer: fine) {
      &:hover {
        .background {
          fill: ${theme<string>("colors.light-purple")};
        }
      }
    }
  `,
  size == IconSize.W28 && tw`w-7 h-7`,
  size == IconSize.W44 && tw`w-7 h-7 tablet:(w-11 h-11)`,
  size == IconSize.W44Fixed && tw`w-11 h-11`,
])

interface ShareProps {
  size: IconSize
  useButton?: boolean // temporary prop till we change ALL of the share buttons to the new format
}
export const Share = (props: ShareProps & ShareContentProps) => {
  const { size, useButton } = props
  const [showShareModal, setShowShareModal] = useState(false)
  const shareModalProps = {
    show: showShareModal,
    setShow: setShowShareModal,
    component: <ShareContent {...props} />,
  }

  const sharebtn = !!useButton ? (
    <Button action={`Share`} icon={<ShareSVG />} twStyle={tw`px-4 py-1 text-xs`} />
  ) : (
    <ShareIcon size={size} />
  )

  return (
    <>
      <div
        data-testid="share"
        onClick={async () => {
          registerEvent(Events.ClickedProfileShare)
          await setShowShareModal(true)
        }}
        tw="relative"
      >
        <>{sharebtn}</>
      </div>
      <Modal {...shareModalProps} />
    </>
  )
}
